module.exports = __webpack_public_path__ + "285010afa10c7d59dbfb823ff9278d28.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/brian-holt.jpg
 ** module id = 403
 ** module chunks = 0
 **/